var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBestaetigung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 219.08,
    height: 234.521,
    viewBox: "0 0 219.08 234.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_170",
    "data-name": "Gruppe 170",
    transform: "translate(-455.491 -628.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_153",
    "data-name": "Gruppe 153",
    transform: "translate(485.576 777.216)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3507",
    "data-name": "Pfad 3507",
    d: "M544.555,991.961H516.679a5.023,5.023,0,0,1-5.017-5.017V911.227a5.023,5.023,0,0,1,5.017-5.017h27.876a5.023,5.023,0,0,1,5.018,5.017v75.718A5.023,5.023,0,0,1,544.555,991.961Zm-27.876-81.467a.733.733,0,0,0-.732.732v75.718a.733.733,0,0,0,.732.732h27.876a.734.734,0,0,0,.734-.732V911.227a.733.733,0,0,0-.734-.732Z",
    transform: "translate(-511.662 -906.21)",
    fill: "#00c713"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_154",
    "data-name": "Gruppe 154",
    transform: "translate(519.419 736.934)",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3508",
    "data-name": "Pfad 3508",
    d: "M641.673,899.331a2.142,2.142,0,0,1-.018-4.285c.071,0,7.218-.059,16.922-.059.331,0,.655,0,.977-.011,12.886-.263,12.886-5.5,12.886-7.218,0-5.975-7.239-7.228-13.311-7.228-1.528,0-3.468.1-5.714.219-7.227.378-17.125.9-24.09-1.557-6.078-2.145-6.751-8.314-5.962-21.331,1.089-17.949-6.608-21.46-14.282-22.526a2.413,2.413,0,0,0-1.986.336c-1.577,1.236-2.034,5.67-2.518,10.364a81.976,81.976,0,0,1-1.965,12.447c-3.474,13.319-23.583,26.757-24.437,27.322a2.142,2.142,0,0,1-2.366-3.572c.2-.13,19.6-13.1,22.657-24.832a78.676,78.676,0,0,0,1.849-11.8c.63-6.111,1.127-10.938,4.135-13.3a6.664,6.664,0,0,1,5.22-1.208c8.348,1.16,19.292,5.225,17.969,27.03-.8,13.264.361,16.06,3.109,17.03,6.165,2.173,15.572,1.68,22.441,1.32,2.306-.121,4.3-.225,5.938-.225,11.183,0,17.6,4.2,17.6,11.513,0,5.088-2.963,11.214-17.078,11.5-.348.009-.706.012-1.07.012-9.686,0-16.815.058-16.886.059Z",
    transform: "translate(-574.851 -831.002)",
    fill: "#00c713"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_155",
    "data-name": "Gruppe 155",
    transform: "translate(519.846 838.479)",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3509",
    "data-name": "Pfad 3509",
    d: "M627.608,1042.641c-19.9,0-48.989-5.468-50.218-5.7a2.142,2.142,0,1,1,.8-4.209c.3.056,29.922,5.625,49.42,5.625,19.869,0,28.816-2.219,29.915-7.418.323-1.529.509-3.6-.44-4.77-.694-.856-2.045-1.289-4.018-1.289H641.854a2.142,2.142,0,1,1,0-4.285h11.211c3.328,0,5.8.967,7.346,2.875,1.615,1.992,2.055,4.8,1.3,8.355C659.811,1040.831,647.253,1042.641,627.608,1042.641Z",
    transform: "translate(-575.646 -1020.594)",
    fill: "#00c713"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_156",
    "data-name": "Gruppe 156",
    transform: "translate(586.401 800.948)",
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3510",
    "data-name": "Pfad 3510",
    d: "M720.649,973.3h-18.6a2.142,2.142,0,0,1,0-4.285h18.6c5.746,0,8.091-2.344,8.091-8.091a5.1,5.1,0,0,0-1.6-4.033c-2.422-2.177-7.2-2.2-8.839-2.022a2.142,2.142,0,0,1-.469-4.259c.316-.035,7.8-.817,12.159,3.082a9.268,9.268,0,0,1,3.034,7.232C733.025,966.567,730.878,973.3,720.649,973.3Z",
    transform: "translate(-699.91 -950.52)",
    fill: "#00c713"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_157",
    "data-name": "Gruppe 157",
    transform: "translate(594.765 819.331)",
    style: {
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3511",
    "data-name": "Pfad 3511",
    d: "M723.454,1008.1h-5.785a2.142,2.142,0,0,1,0-4.285h5.785c5.745,0,8.089-2.344,8.089-8.09a5.483,5.483,0,0,0-1.659-4.245c-2.378-2.224-6.949-2.437-8.508-2.335a2.142,2.142,0,0,1-.3-4.274c.3-.02,7.477-.485,11.72,3.465a9.668,9.668,0,0,1,3.032,7.388C735.828,1001.368,733.681,1008.1,723.454,1008.1Z",
    transform: "translate(-715.527 -984.843)",
    fill: "#00c713"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_158",
    "data-name": "Gruppe 158",
    transform: "translate(494.765 833.26)",
    style: {
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3512",
    "data-name": "Pfad 3512",
    d: "M537.985,1029.185a9.168,9.168,0,1,1,9.169-9.169A9.179,9.179,0,0,1,537.985,1029.185Zm0-14.051a4.883,4.883,0,1,0,4.884,4.883A4.888,4.888,0,0,0,537.985,1015.134Z",
    transform: "translate(-528.818 -1010.849)",
    fill: "#00c713"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_159",
    "data-name": "Gruppe 159",
    transform: "translate(482.555 733.653)",
    style: {
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3513",
    "data-name": "Pfad 3513",
    d: "M524.1,829.16H508.164a2.142,2.142,0,1,1,0-4.285H524.1a2.142,2.142,0,1,1,0,4.285Z",
    transform: "translate(-506.022 -824.875)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_160",
    "data-name": "Gruppe 160",
    transform: "translate(490.522 725.686)",
    style: {
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3514",
    "data-name": "Pfad 3514",
    d: "M523.039,830.218a2.143,2.143,0,0,1-2.142-2.142V812.142a2.142,2.142,0,0,1,4.285,0v15.933A2.143,2.143,0,0,1,523.039,830.218Z",
    transform: "translate(-520.897 -810)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_161",
    "data-name": "Gruppe 161",
    transform: "translate(674.107 826.547)",
    style: {
      isolation: "isolate"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3515",
    "data-name": "Pfad 3515",
    d: "M864.128,1000.456l-.174.084-.193,0a2.416,2.416,0,0,1,.367-2.222Z",
    transform: "translate(-863.664 -998.315)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_162",
    "data-name": "Gruppe 162",
    transform: "translate(485.706 758.417)",
    style: {
      isolation: "isolate"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3516",
    "data-name": "Pfad 3516",
    d: "M520.565,877.555c-1.7,0-3.406.052-5.106-.013-2.131-.081-3.553-1.415-3.554-3.211s1.432-3.149,3.553-3.181c3.332-.05,6.667-.055,10,0a3.212,3.212,0,0,1,3.423,3.072,3.264,3.264,0,0,1-3.423,3.314C523.83,877.616,522.2,877.554,520.565,877.555Z",
    transform: "translate(-511.905 -871.111)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_163",
    "data-name": "Gruppe 163",
    transform: "translate(603.283 758.427)",
    style: {
      isolation: "isolate"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3517",
    "data-name": "Pfad 3517",
    d: "M740,871.152c1.7,0,3.407-.06,5.105.016a3.216,3.216,0,0,1,3.285,3.216,3.176,3.176,0,0,1-3.161,3.132q-5.314.157-10.635,0a3.108,3.108,0,0,1-3.147-3.324,3.148,3.148,0,0,1,3.234-3.039c.141-.008.283-.01.425-.01H740Z",
    transform: "translate(-731.431 -871.129)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_164",
    "data-name": "Gruppe 164",
    transform: "translate(515.125 758.427)",
    style: {
      isolation: "isolate"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3518",
    "data-name": "Pfad 3518",
    d: "M575.455,871.149c1.631,0,3.263-.047,4.892.01a3.2,3.2,0,0,1,3.42,3.068,3.159,3.159,0,0,1-3.192,3.294q-5.312.151-10.632-.009a3.129,3.129,0,0,1-3.11-3.165,3.207,3.207,0,0,1,3.306-3.181C571.908,871.095,573.683,871.151,575.455,871.149Z",
    transform: "translate(-566.833 -871.13)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_165",
    "data-name": "Gruppe 165",
    transform: "translate(515.136 732.497)",
    style: {
      isolation: "isolate"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3519",
    "data-name": "Pfad 3519",
    d: "M575.216,829.116c-1.7,0-3.4.05-5.1-.013a3.075,3.075,0,0,1-3.242-2.994,2.973,2.973,0,0,1,2.909-3.27c3.675-.158,7.366-.158,11.041-.013a2.99,2.99,0,0,1,2.931,3.261,3.068,3.068,0,0,1-3.22,3.019C578.761,829.154,576.988,829.115,575.216,829.116Z",
    transform: "translate(-566.854 -822.718)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_166",
    "data-name": "Gruppe 166",
    transform: "translate(573.932 758.427)",
    style: {
      isolation: "isolate"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3520",
    "data-name": "Pfad 3520",
    d: "M685.171,871.153c1.71,0,3.422-.059,5.129.017a3.134,3.134,0,0,1,3.2,3.057,3.028,3.028,0,0,1-2.979,3.271c-3.628.126-7.267.125-10.9,0a3.063,3.063,0,0,1-2.995-3.262,3.131,3.131,0,0,1,3.2-3.068C681.606,871.091,683.39,871.153,685.171,871.153Z",
    transform: "translate(-676.63 -871.13)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_167",
    "data-name": "Gruppe 167",
    transform: "translate(573.955 732.484)",
    style: {
      isolation: "isolate"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3521",
    "data-name": "Pfad 3521",
    d: "M684.956,829.1c-1.709,0-3.423.079-5.126-.023A3.016,3.016,0,0,1,676.673,826a2.937,2.937,0,0,1,3.009-3.215c3.625-.123,7.262-.139,10.884.024a2.89,2.89,0,0,1,2.94,3.253,3.012,3.012,0,0,1-3.209,3.022C688.52,829.16,686.737,829.1,684.956,829.1Z",
    transform: "translate(-676.673 -822.693)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_168",
    "data-name": "Gruppe 168",
    transform: "translate(603.293 732.507)",
    style: {
      isolation: "isolate"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3522",
    "data-name": "Pfad 3522",
    d: "M739.882,829.106c-1.772,0-3.549.085-5.315-.023a3.079,3.079,0,0,1-3.113-3.114c.1-1.756,1.044-3.056,2.866-3.12,3.678-.131,7.367-.154,11.045-.034a2.906,2.906,0,0,1,2.982,3.216A2.978,2.978,0,0,1,745.2,829.1c-1.77.07-3.544.015-5.316.015Z",
    transform: "translate(-731.449 -822.736)",
    fill: "#00467d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_169",
    "data-name": "Gruppe 169",
    transform: "translate(455.491 628.447)",
    style: {
      isolation: "isolate"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3523",
    "data-name": "Pfad 3523",
    d: "M674.571,821.408c-.482-1.728-.306-3.525-.547-5.279-2.209-16.046-4.824-32.03-7.252-48.043q-5.214-34.393-10.445-68.783c-1.878-12.417-3.583-24.863-5.715-37.239-1.6-9.311-8.738-15.162-18.145-15.18-5.557-.011-11.113.009-16.669-.007-2.841-.008-2.961-.148-2.985-3.056-.018-2.213.078-4.427-.042-6.637a8.857,8.857,0,0,0-7.2-8.441c-6.719-1.479-12.155,2.709-12.423,9.6-.083,2.139-.035,4.282-.023,6.422.008,1.383-.48,2.119-1.982,2.119q-14.639,0-29.278,0c-1.434,0-2.075-.6-2.064-2.044.018-2.283.035-4.568-.01-6.851-.112-5.711-3.9-9.431-9.639-9.5-5.769-.073-9.718,3.528-10,9.173-.114,2.281-.078,4.568-.022,6.85.043,1.749-.693,2.4-2.416,2.39q-14.318-.048-28.637,0c-1.617,0-2.323-.595-2.3-2.255.04-2.5.146-5-.058-7.491-.437-5.344-4.461-8.773-10.068-8.664s-9.35,3.7-9.526,9.153q-.11,3.424,0,6.85c.052,1.735-.629,2.436-2.378,2.411-3.988-.057-7.978-.044-11.967-.011A17.036,17.036,0,0,0,455.509,664.1q-.044,80.822-.006,161.645a15.215,15.215,0,0,0,1.9,8.007c3.931,6.629,9.9,9.3,17.361,9.3,7.056,0-.885,0,6.171,0v-7.126H474.31c-7.794,0-12.186-4.395-12.187-12.183q-.006-52.773-.044-105.547c0-1.755.373-2.212,2.173-2.207q37.932.1,75.864.046c.5,0,1,.008,1.5,0,2.617-.046,4.131-1.292,4.061-3.338-.068-1.992-1.463-3.088-4.051-3.089q-30.239-.013-60.477,0c-5.77,0-11.54-.05-17.309.035-1.424.021-1.765-.4-1.748-1.777.049-3.833-.016-3.834,3.7-3.834q87.724,0,175.448-.054c2.144,0,2.964.488,2.585,2.634a7.726,7.726,0,0,0-.008,1.923c.066.845-.282,1.159-1.106,1.08-.494-.048-1-.009-1.495-.009q-40.924,0-81.848,0a17.494,17.494,0,0,0-2.134.045,2.945,2.945,0,0,0-2.871,2.895,2.976,2.976,0,0,0,2.586,3.369,10.6,10.6,0,0,0,2.337.119q41.138.007,82.275-.044c1.878,0,2.305.434,2.3,2.3-.085,15.842-.052,31.685-.04,47.528a9.151,9.151,0,0,0,.225,2.538,2.888,2.888,0,0,0,3.222,2.211,2.972,2.972,0,0,0,2.888-2.656,11.756,11.756,0,0,0,.075-2.135q0-27.3,0-54.593v-2.35l.313-.007q3.04,19.842,6.08,39.685,3.949,25.78,7.894,51.56c1.183,7.749,2.436,15.489,3.482,23.257.981,7.284-3.648,12.5-10.973,12.592-3.389.042-6.78.007-10.734.007,4.7-5.568,3.927-11.879,3.935-18.034q.021-16.913,0-33.827a12.357,12.357,0,0,0-.052-1.923,2.975,2.975,0,0,0-2.982-2.792,2.944,2.944,0,0,0-3.243,2.479,9.968,9.968,0,0,0-.137,2.34q-.01,19.8-.007,39.607c0,7.784-4.385,12.147-12.208,12.147-9.693,0-3.317,0-13.01,0v7.127c17.968,0,19.867,0,37.835,0a22.847,22.847,0,0,0,6.118-.851c6.077-1.681,12.1-7.784,11.813-13.141.107-.837-.232-1.711.221-2.516Zm-74.3-183.061c.006-2.12.764-2.75,2.876-2.774,1.868-.021,2.714.783,2.689,2.706-.059,4.563-.019,9.127-.019,13.69,0,4.421-.049,8.842.022,13.262.032,1.97-.689,2.926-2.733,2.863-2.126-.065-2.831-.639-2.836-2.8Q600.235,651.823,600.271,638.347Zm9.981,33.541c-.3,4.413-3.555,7.529-7.555,7.239a6.962,6.962,0,0,1-6.672-7.086A10.919,10.919,0,0,0,610.252,671.888ZM549.9,635.573c2.2.02,2.841.625,2.849,2.973.013,4.421,0,8.843,0,13.265,0,4.493.014,8.986-.006,13.478-.01,2.212-.62,2.8-2.78,2.789-2.112-.006-2.76-.63-2.764-2.829-.016-8.914.018-17.829-.026-26.743C547.168,636.565,547.873,635.555,549.9,635.573Zm7.106,36.471a6.913,6.913,0,0,1-6.81,7.093,7.159,7.159,0,0,1-7.316-7.166C547.979,675.529,551.956,675.524,557.006,672.044Zm-60.232-36.472c2.128,0,2.9.64,2.917,2.719.032,4.493.01,8.985.01,13.478s.017,8.985-.006,13.478c-.012,2.191-.668,2.825-2.774,2.831-2.177.006-2.766-.553-2.77-2.79-.014-8.985.019-17.971-.026-26.956C494.116,636.434,494.89,635.57,496.775,635.572Zm7.04,36.491c.491,3.414-2.478,6.67-6.428,7.049a7.05,7.05,0,0,1-7.568-7.069C495.457,675.471,499.175,675.476,503.815,672.064ZM641.68,697.649q-44.445-.1-88.889-.047-44.231,0-88.462.038c-1.689,0-2.279-.268-2.259-2.144.109-9.917.039-19.836.055-29.755.012-7.413,4.413-11.8,11.833-11.827,3.989-.014,7.979.077,11.965-.043,1.562-.047,2.027.469,1.814,1.921a7.833,7.833,0,0,0-.008,1.71,8.986,8.986,0,0,1-1.992,6.614c-4.324,5.638-3,13.757,2.564,18.4a13.776,13.776,0,0,0,18.434-1.155,13.529,13.529,0,0,0,.4-18.417c-1.333-1.466-.975-3.023-.995-4.591-.056-4.436-.019-4.437,4.327-4.437,9.4,0,18.8.06,28.2-.051,1.855-.022,2.4.535,2.11,2.241a5.231,5.231,0,0,0-.006,1.068,10.035,10.035,0,0,1-1.973,7.048c-4.338,5.782-2.889,13.867,2.711,18.331a13.7,13.7,0,0,0,18.256-1.141,13.534,13.534,0,0,0,.362-18.576c-1.328-1.484-.911-3.056-.936-4.622-.068-4.3-.023-4.3,4.262-4.3,9.544,0,19.089.026,28.632-.03,1.349-.008,1.967.278,1.764,1.731a12.054,12.054,0,0,0-.012,2.351,8.152,8.152,0,0,1-1.817,6.025,13.246,13.246,0,0,0-.105,15.755A13.679,13.679,0,0,0,616.752,672c.021-2.9-.555-5.886-2.577-7.955-1.984-2.03-1.969-4.229-1.942-6.651.039-3.483.01-3.483,3.432-3.483,5.555,0,11.111-.028,16.667.007,6.992.044,11.447,4.517,11.467,11.529.027,9.99-.038,19.98.05,29.969C643.863,697.148,643.511,697.653,641.68,697.649Z",
    transform: "translate(-455.491 -628.447)",
    fill: "#00467d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestaetigung);
export default __webpack_public_path__ + "static/media/bestaetigung.2ff38496.svg";
export { ForwardRef as ReactComponent };